import { ExternalSystemObjectValuesResponce } from "../document";

export class ExternalSystemGetObjectValuesResult {
  constructor(
    public isOk: boolean,
    public message: string,
    public result: ExternalSystemObjectValuesResponce,
  ) {}
}
